import { render } from "./DropdownWithTags.vue?vue&type=template&id=6d91ee0d"
import script from "./DropdownWithTags.vue?vue&type=script&lang=js"
export * from "./DropdownWithTags.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__